import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'enableActionItemFilter'
})
export class EnableActionItemFilterPipe implements PipeTransform {
  transform(value: any[]) {
    return value.filter(x => x.enabled);
  }
}
